import React from 'react';

const StepProgress = ({ steps, currentStep, completedColor, inProgressColor, incompleteColor }) => {
  return (
    <div style={styles.container}>
      {steps.map((step, index) => (
        <div key={index} style={styles.stepContainer}>
          <div style={styles.stepAndLine}>
            <div
              style={{
                ...styles.step,
                backgroundColor: 
                  index < currentStep - 1 ? completedColor :
                  index === currentStep - 1 ? inProgressColor :
                  incompleteColor,
                color: index < currentStep ? '#fff' : '#000',
              }}
            >
              {index + 1}
            </div>
            {index < steps.length - 1 && (
              <div
                style={{
                  ...styles.line,
                  backgroundColor: 
                    index < currentStep - 1 ? completedColor :
                    index === currentStep - 1 ? inProgressColor :
                    incompleteColor,
                }}
              />
            )}
          </div>
          <div style={styles.stepName}>{step}</div>
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '800px',
    margin: '5px auto',
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '20%',
  },
  stepAndLine: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  step: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    zIndex: 1,
    flexShrink: 0,
  },
  line: {
    flexGrow: 1,
    height: '2px',
    margin: '0 -5px',
  },
  stepName: {
    marginTop: '8px',
    fontSize: '10px',
    textAlign: 'center',
    maxWidth: '100%',
    wordWrap: 'break-word',
    color: '#000',
  },
};

export default StepProgress;